import { makeStyles } from 'lib/components';

export default makeStyles(() => ({
  progressBar: {
    width: '70%',
  },
  progressBarContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '300px',
  },
}));
